var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',[_c('q-card-section',[_vm._t("header",function(){return [(_vm.title)?_c('div',{staticClass:"text-h6"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]):_vm._e()]}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }